import { useState } from "react";

import { FloatingWindow } from "src/base-components/FloatingWindow/FloatingWindow";
import { MarkdownRenderer } from "src/base-components/MarkdownRenderer/MarkdownRenderer";
import {
  buildOpenStringValueCallback,
  isLargeStringValue,
  trimLargeString,
} from "src/dataTable/TableUtils";

export const MultilineDataValue: React.FC<{
  fieldName: string;
  value: string;
  preserveFormattingForLargeStrings?: boolean;
}> = ({ fieldName, value, preserveFormattingForLargeStrings = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const shouldTrim =
    !preserveFormattingForLargeStrings && isLargeStringValue(value, "multi");
  const valueToUse = shouldTrim ? trimLargeString(value, "multi") : value;

  return (
    <div className="relative min-w-0 flex-1" data-loc="multiline-content">
      <div className="line-clamp-5 break-words text-left">
        <MarkdownRenderer content={valueToUse} dataLoc="markdown-preview" />
      </div>

      <FloatingWindow
        button={
          <button
            className="ml-auto flex cursor-pointer items-center font-inter-normal-12px text-indigo-700 underline"
            data-loc="see-more-button"
            onClick={() => {
              if (shouldTrim) {
                buildOpenStringValueCallback(value)();
              } else {
                setIsOpen(true);
              }
            }}
          >
            See more
          </button>
        }
        isOpen={isOpen}
        maximizable={false}
        pinnable={false}
        title={fieldName}
        resizeable
        onClose={() => setIsOpen(false)}
      >
        <div className="flex h-full flex-col">
          <div className="decideScrollbar h-full flex-1 break-words py-3 pr-1 pl-2">
            <MarkdownRenderer content={valueToUse} />
          </div>
          <div className="mt-3" />
        </div>
      </FloatingWindow>
    </div>
  );
};
